import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M.5 4.5h15c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H.5c-.3 0-.5.2-.5.5s.2.5.5.5m15 3H.5c-.3 0-.5.2-.5.5s.2.5.5.5h15c.3 0 .5-.2.5-.5s-.2-.5-.5-.5m0 4H.5c-.3 0-.5.2-.5.5s.2.5.5.5h15c.3 0 .5-.2.5-.5s-.2-.5-.5-.5" />
  </svg>
);
const SvgLines = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="lines" {...props} />;
export default SvgLines;
